import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { getChannelDomain, getOrganisationUrl, getWebAppUrl, JSONEditor } from '../../../../shared';

import classes from './AppConfig.module.scss';

export const AppConfig: FunctionComponent = () => {
  const { t: ctxT } = useTranslation('', { keyPrefix: 'orgDashboardAppConfig' });

  return (
    <div className={classes['config']}>
      <div
        className={classes['config__link']}
        onClick={() =>
          window.open(
            `${getWebAppUrl(
              getChannelDomain()
            )}/static/app_config_editor.html?organisationUrl=${encodeURIComponent(
              getOrganisationUrl()
            )}`,
            '_blank',
            'noopener, noreferrer'
          )
        }
      >
        {ctxT('open-editor')}
      </div>

      <JSONEditor
        id={'webapp-config'}
        schemaUrl={`${getOrganisationUrl()}/v1/webapp/config/schema`}
        configUrl={`${getOrganisationUrl()}/v1/webapp/config`}
      />
    </div>
  );
};
